import { render, staticRenderFns } from "./SalesSetting.vue?vue&type=template&id=3867c159&scoped=true&"
import script from "./SalesSetting.vue?vue&type=script&lang=js&"
export * from "./SalesSetting.vue?vue&type=script&lang=js&"
import style0 from "./SalesSetting.vue?vue&type=style&index=0&id=3867c159&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3867c159",
  null
  
)

export default component.exports